import { useRef, useEffect } from 'react';

const HIGHLIGHTS = [
  { icon: 'ri-scales-3-line', text: 'Análise técnica e criteriosa de cada caso' },
  { icon: 'ri-shield-check-line', text: 'Compromisso absoluto com ética e resultados' },
  { icon: 'ri-user-star-line', text: 'Atendimento direto e personalizado' },
  { icon: 'ri-lightbulb-line', text: 'Consultoria jurídica preventiva e estratégica' },
  { icon: 'ri-building-4-line', text: 'Atuação especializada em consultoria jurídica' },
];

export default function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );

    const children = sectionRef.current?.querySelectorAll('.animate-fade');
    children?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" className="py-32 bg-white" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Image Column */}
          <div className="animate-fade opacity-0 translate-y-8 transition-all duration-700">
            <div className="relative">
              {/* Gold border frame */}
              <div className="absolute -top-4 -left-4 w-full h-full border-2 border-[#C6935A]/40 rounded-lg" />
              <div className="relative rounded-lg overflow-hidden" style={{ height: '580px' }}>
                <img
                  src="https://storage.readdy-site.link/project_files/d16c2237-912b-479f-a39a-531391a6a5bd/a11f1130-002f-46a4-b9dc-b54d98f43a69_RAF_7815---Diogo-Calasans-foto.png?v=a833c3a11f45486487db98b18d119b1e"
                  alt="Dr. Diogo de Calasans Melo Andrade – Advogado em Aracaju"
                  className="w-full h-full object-cover object-top"
                />
                {/* Overlay badge */}
                <div className="absolute bottom-6 left-6 right-6 bg-[#173A4D]/95 backdrop-blur-sm rounded-lg p-5">
                  <p className="text-[#D4A873] text-xs font-600 tracking-widest uppercase mb-1">OAB/SE</p>
                  <p className="text-white font-600 text-lg">Diogo de Calasans Melo Andrade</p>
                </div>
              </div>
            </div>
          </div>

          {/* Text Column */}
          <div className="animate-fade opacity-0 translate-y-8 transition-all duration-700 delay-200">
            {/* Section Label */}
            <p className="text-[#C6935A] text-xs font-600 tracking-[3px] uppercase mb-4">
              Sobre o Advogado
            </p>

            <h2 className="text-4xl lg:text-5xl font-700 text-[#1F4B63] leading-tight mb-6">
              Inteligência jurídica a serviço das suas decisões
            </h2>

            <div className="w-16 h-0.5 bg-[#C6935A] mb-8" />

            <p className="text-[#4A5568] text-base leading-relaxed mb-5">
              Com atuação focada em <strong className="text-[#1F4B63]">consultoria jurídica estratégica</strong>, o escritório de Diogo de Calasans Melo Andrade oferece orientação jurídica de excelência para pessoas físicas e jurídicas que buscam segurança e clareza nas suas decisões.
            </p>

            <p className="text-[#4A5568] text-base leading-relaxed mb-10">
              Cada caso é tratado com profundidade técnica, análise criteriosa e comprometimento com o resultado. O atendimento é direto, personalizado e pautado nos mais elevados padrões éticos da advocacia.
            </p>

            {/* Highlights */}
            <ul className="space-y-4">
              {HIGHLIGHTS.map((item) => (
                <li key={item.text} className="flex items-start gap-4">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#C6935A] text-xl`} />
                  </div>
                  <span className="text-[#2D3748] font-500 text-base">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
